import { render, staticRenderFns } from "./DynamicContentComponent.vue?vue&type=template&id=ff0d60c6&scoped=true&"
import script from "./DynamicContentComponent.vue?vue&type=script&lang=ts&"
export * from "./DynamicContentComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0d60c6",
  null
  
)

export default component.exports